import { createModel } from '@preact/signals-react';
import type { Model, ModelConstructor, ReadonlySignal } from '@preact/signals-react';
import type { Logger } from '@thinkalpha/ui-ioc/core/types/Logger';
import { AGGREGATED_RISK_WIDGET_CONFIG_BY_KIND, columnTemplateStateSchema } from 'src/features/aggregated-risk/config';
import { AggregatedRiskSelfOwnedModel } from 'src/models/AggregatedRiskWidgetModel/AggregatedRiskSelfOwnedModel';
import type { AggregatedRiskSelfOwnedModelShape } from 'src/models/AggregatedRiskWidgetModel/AggregatedRiskSelfOwnedModel';
import { stickyFilterStateSchema } from 'src/models/StickyFilterModel';
import type { TableModel } from 'src/models/TableModel';
import type { WidgetId } from 'src/services/WorkspaceService/selfOwnedWidget';
import type { WidgetContainerController } from 'src/services/WorkspaceService/WidgetContainer/WidgetContainer';
import type { ReactBindings } from 'src/types/bindings';
import type { z } from 'zod';

export const tradersWidgetStateSchema = stickyFilterStateSchema.extend({
    columnTemplate: columnTemplateStateSchema,
});

export type TradersWidgetState = z.infer<typeof tradersWidgetStateSchema>;

interface TradersSelfOwnedModelInit {
    container: WidgetContainerController;
    tabId: WidgetId;
    persisted: TradersWidgetState;
    logger: Logger;
    queryClient: ReactBindings['QueryClient'];
    slugMapService: ReactBindings['SlugMapService'];
    table: TableModel;
    columnFiltersEnabled: ReadonlySignal<boolean>;
}

export const TradersSelfOwnedModel: ModelConstructor<AggregatedRiskSelfOwnedModelShape, [TradersSelfOwnedModelInit]> =
    createModel<AggregatedRiskSelfOwnedModelShape, [TradersSelfOwnedModelInit]>((init: TradersSelfOwnedModelInit) => {
        return new AggregatedRiskSelfOwnedModel({
            ...init,
            config: AGGREGATED_RISK_WIDGET_CONFIG_BY_KIND.traders,
        });
    });

export type TradersSelfOwnedModel = Model<AggregatedRiskSelfOwnedModelShape>;
